import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-product-modal',
  templateUrl: './product-modal.page.html',
  styleUrls: ['./product-modal.page.scss'],
})
export class ProductModalPage implements OnInit {
  @Input() productArray: { name: string, assigned: boolean }[];
  productName: string;
  counter = 1;

  constructor(public modalController: ModalController) { }

  ngOnInit() {
    if (!this.productArray) {
      this.productArray = [];
    }
  }

  addProduct() {
    if (this.productName) {
      for (let i = 1; i <= this.counter; i++) {
        this.productArray.push({ name: this.productName, assigned: false });
      }
      this.counter = 1;
      this.productName = null;
    }
  }

  updateCounter(option) {
    if (option === 'sum') {
      this.counter++;
    } else {
      if (this.counter > 1) {
        this.counter--;
      }
    }
  }

  deleteProd(index) {
    this.productArray.splice(index, 1);
  }

  dismiss() {
    this.modalController.dismiss({
      products: this.productArray
    });
  }

}
